import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  'Register-Connect-Dialog-root': {
    padding: 32,
    maxWidth: 424,
    borderRadius: 16,
    '& .connect-logo': {
      marginBottom: 20
    }
  },
  'Register-Connect-Dialog-Checkbox-root': {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20,
    marginBottom: 32,
    padding: '8px 0px',
    '& .MuiCheckbox-root': {
      padding: 0,
      marginRight: 12
    },
    '& .underline': {
      textDecoration: 'underline'
    }
  }
}));

export default useStyles;
